import React from 'react'
import withStyles from 'isomorphic-style-loader/withStyles';
import { Container, Row, Col } from 'react-bootstrap';
import cx from 'classnames';
import Skeleton from '../../../Common/Skeleton/Skeleton'
import s from './FooterSkeleton.css'


function FooterSkeleton() {
    return (
        <footer className={s.FooterSkeletonContainer}>
            <Container>
                <Row className={s.FooterSkeletonRow}>
                    <Col xl={6} lg={6} md={6} sm={12} xs={12}>
                        <div className={s.footerSkeletonWrapper}>
                            <Skeleton className={s.footerSkeletonHeading1} />
                            <div className={s.footerSkeletonAboutList}>
                                {[1, 2, 3, 4].map((n) => <div key={n}>
                                    <Skeleton className={cx(s.footerSkeletonAboutListItem, s[`footerSkeletonAboutListItem${n}`])} />
                                </div>)}
                            </div>
                        </div>
                    </Col>
                    <Col xl={3} lg={6} md={6} sm={12} xs={12}>
                        <div className={s.footerSkeletonWrapper}>
                            <Skeleton className={s.footerSkeletonHeading2} />
                            <div className={s.footerSkeletonFollowUsList}>
                                {[1, 2, 3, 4].map((n) => <div key={n}>
                                    <Skeleton className={s.footerSkeletonFollowUsListItem} />
                                </div>)}
                            </div>
                        </div>
                    </Col>
                    <Col xl={3} lg={6} md={6} sm={12} xs={12}>
                        <div className={s.footerSkeletonWrapper}>
                            <Skeleton className={s.footerSkeletonHeading3} />
                            <div className={s.footerSkeletonPaymentList}>
                                {[1, 2, 3, 4].map((n) => <div key={n}>
                                    <Skeleton className={s.footerSkeletonPaymentListItem} />
                                </div>)}
                            </div>
                        </div>
                    </Col>
                </Row>
                <div className={s.copyRightSkeletonContainer}>
                    <Skeleton className={s.copyRightSkeletonDesc} />
                </div>
            </Container>
        </footer>
    )
}

export default withStyles(s)(FooterSkeleton);
